import { createApp } from 'vue'
import App from './App.vue'
import "./main.css"
import router from './router'
import global from './global'
import WorkingAndError from './components/ui/WorkingAndError.vue'
import LoginDialog from './components/LoginDialog.vue'
import LoadingData from './components/ui/LoadingData.vue'
import Modal from "./components/ui/Modal.vue"
import SidePanel from "./components/ui/SidePanel.vue"
import Popper from "vue3-popper"
import NoAccess from "./components/utils/NoAccess.vue"
import ErrorDisplay from "./components/utils/ErrorDisplay.vue"
import AiPromptCard from "@/components/ai/AiPromptCard.vue"


const app = createApp(App).use(router)

app.config.errorHandler = (err, instance, info) => {
  console.error('[Vue Error]', err, info)
  global.setAppError(err)
}

window.addEventListener('error', (event) => {
  if (!global.appError?.value) {
    console.error('[Unhandled Error]', event.error)
    global.setAppError(event.error || event.message)
  }
})

window.addEventListener('unhandledrejection', (event) => {
  if (!global.appError?.value) {
    console.error('[Unhandled Promise Rejection]', event.reason)
    global.setAppError(event.reason instanceof Error ? event.reason : new Error(String(event.reason)))
    event.preventDefault()
  }
})

// Temporarily suppress Vue warnings for undefined properties
//app.config.warnHandler = (msg, instance, trace) => {
//  // Suppress warnings about w9ToValidate and other undefined properties
//  if (msg.includes('was accessed during render but is not defined') || 
//      msg.includes('w9ToValidate')) {
//    return; // Suppress this warning
//  }
//  console.warn(msg, instance, trace);
//};

app.component("LoginDialog",LoginDialog)
app.component("Popper",Popper)
app.component("WorkingAndError",WorkingAndError)
app.component("LoadingData", LoadingData)
app.component("Modal", Modal)
app.component("SidePanel", SidePanel)
app.component("NoAccess",NoAccess)
app.component("ErrorDisplay",ErrorDisplay)
app.component("AiPromptCard",AiPromptCard)


app.mount('#app')

